<script>
export default {
    data () {
        return {
            help: null,
            helpEl: null,
            buttonEl: null,
        };
    },
    computed: {
        blockSubmit () {
            return (this.help === 'Book an Appointment');
        }
    },
    mounted () {
        // have to do this because Perch removes the v-model and ref attributes
        this.helpEl = this.$el.querySelectorAll('select[name=help]')[0];
        this.buttonEl = this.$el.querySelectorAll('#contact-form-button')[0];

        this.helpEl.addEventListener('change', this.helpChanged);
        this.helpEl.form.addEventListener('submit', this.submit);
        this.buttonEl.addEventListener('click', this.submit);
    },
    methods: {
        helpChanged (e) {
            this.help = e.target.options[e.target.selectedIndex].value;
        },
        submit (e) {
            if (this.blockSubmit) {
                alert('To book an appointment, please use our online appointment request form or email us at office@aviationdoc.com');

                e.preventDefault();
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// html/js/src/public/contact_form/index.vue